import { DiscountLeftPanelSide } from 'app/src/features/Shopping/Discount/components/DiscountLeftPanelSide'
import { DiscountRightPanelSide } from 'app/src/features/Shopping/Discount/components/DiscountRightPanelSide'
import { DiscountWidget } from 'app/src/features/Shopping/Discount/components/DiscountWidget'
import { shoppingApi } from 'app/src/services/welfareportal'
import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

export function DiscountDetails(props: { order: shoppingApi.OrderDetails; funnelMode?: boolean }) {
  const { t } = useTranslation('shopping', { keyPrefix: 'Direct.Discount' })
  const orderDetailDiscount = props.order?.purchaseDetails as shoppingApi.OrderDetailsPurchaseDiscount

  const [showUsageModal, setShowUsageModal] = useState(false)

  const renderDetailDescription = useMemo(() => {
    if (orderDetailDiscount?.purchaseDescription)
      return (
        <div className='printable my-10 grid grid-cols-12'>
          <div className='col-span-12 rounded-[10px] border-[3px] border-solid border-[var(--primary-color)] p-3'>
            {orderDetailDiscount?.purchaseDescription && (
              <div>
                <div className='text-[16px] font-bold leading-6'>{t('detailExternalPurchaseTitleDesc')}</div>
                <div
                  className='list-container-bullet-disc mt-1 text-wrap py-2 pl-10 text-[16px] font-normal leading-6'
                  dangerouslySetInnerHTML={{ __html: orderDetailDiscount.purchaseDescription }}
                ></div>
              </div>
            )}
          </div>
        </div>
      )
    else return
  }, [t, orderDetailDiscount.purchaseDescription])
  return (
    <div className='mx-auto max-w-5xl'>
      {(typeof props.funnelMode === 'undefined' || !props.funnelMode) && (
        <div className='noPrint'>
          <h1 className='welfareportal-titlecenter'>{t('detailPageTitle')}</h1>

          <div className='card grid grid-cols-1 divide-x-0 divide-y-2 p-5 lg:grid-cols-12 lg:divide-x-2 lg:divide-y-0'>
            <DiscountLeftPanelSide
              statusMode
              order={props.order}
              setShowUsageModal={setShowUsageModal}
              showUsageModal={showUsageModal}
            />
            <DiscountRightPanelSide order={props.order} />
          </div>
        </div>
      )}
      {renderDetailDescription}
      <DiscountWidget order={props.order} />
    </div>
  )
}
